import { css } from "@emotion/react";
import { MEDIA_QUERY_FOR_PC } from "constants/mediaQueryForPc";
import { MEDIA_QUERY_FOR_SP } from "constants/mediaQueryForSp";

const calendarInnerWidth = css`
  ${MEDIA_QUERY_FOR_PC} {
    width: 378px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    width: 298px;
  }
`;

const calendarContentGap = css`
  ${MEDIA_QUERY_FOR_PC} {
    margin-top: 12px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    margin-top: 10px;
  }
`;

const calendarDayButtonRectangle = css`
  ${MEDIA_QUERY_FOR_PC} {
    width: 50px;
    height: 44px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    width: 40px;
    height: 34px;
  }
`;

// カレンダー全体のコンテナスタイル
const calendarContainerStyle = css`
  .react-datepicker {
    border: 1px solid #e6e6e6;
    border-radius: 16px;
    background-color: #f9f9f9;
    box-shadow: 0px 1px 2px 0px #000e3340;
    padding: 24px;
    font-family: inherit;

    ${MEDIA_QUERY_FOR_PC} {
      width: 426px;
    }

    ${MEDIA_QUERY_FOR_SP} {
      width: 336px;
    }
  }
`;

// カレンダーレイアウトスタイル
const calendarLayoutStyle = css`
  .react-datepicker__month-container {
    display: flex;
    flex-direction: column;
  }
  .react-datepicker__header {
    background-color: transparent;
    border-bottom: none;

    ${calendarInnerWidth};
  }
  .react-datepicker__month {
    margin-inline: 0;

    ${calendarContentGap};
  }
  .react-datepicker__week {
    display: flex;

    ${calendarInnerWidth};
  }
`;

// 日付名ヘッダースタイル
const dayNamesStyle = css`
  .react-datepicker__day-names {
    background-color: transparent;
    display: flex;
    justify-content: space-between;

    ${calendarInnerWidth};
    ${calendarContentGap};
    .react-datepicker__day-name {
      border-radius: 4px;
      color: #6c757d;
      font-weight: 700;
      line-height: 1.4;
      display: grid;
      place-content: center;

      ${calendarDayButtonRectangle};

      ${MEDIA_QUERY_FOR_PC} {
        font-size: 14px;
      }

      ${MEDIA_QUERY_FOR_SP} {
        font-size: 11px;
      }
    }
  }
`;

// 日付セルスタイル
const dayStyle = css`
  .react-datepicker__day {
    border-radius: 6px;
    display: grid;
    place-content: center;
    color: #1f1f1f;
    font-size: 18px;
    font-weight: 500;
    background: #ffffff;
    box-shadow: 0px 1px 1px 0px #000e330d;
    &:hover {
      background: #e9ecef;
    }
    &--selected {
      border: 2px solid #0047ff;
    }
    &--outside-month {
      background-color: transparent;
      color: #00175426;
      box-shadow: none;
    }

    ${calendarDayButtonRectangle};

    ${MEDIA_QUERY_FOR_PC} {
      font-size: 18px;
    }

    ${MEDIA_QUERY_FOR_SP} {
      font-size: 14px;
    }
  }
  .react-datepicker__day,
  .react-datepicker__time-name {
    margin: 2px;
    gap: 2px;
  }
  .react-datepicker__day--disabled {
    color: #00175426;
    cursor: not-allowed;
  }
`;

export const detailedSearchCalendarStyles = css`
  ${calendarContainerStyle}
  ${calendarLayoutStyle}
  ${dayNamesStyle}
  ${dayStyle}
`;

export const yearDisplayStyle = css`
  font-size: 16px;
  font-weight: bold;
`;

export const monthToggleButtonStyle = css`
  border: none;
  cursor: pointer;

  width: 128px;
  height: 44px;
  border-radius: 6px;
  padding-top: 10px;
  padding-right: 12px;
  padding-bottom: 10px;
  padding-left: 12px;
  background: #ffffff;
  box-shadow: 0px 1px 1px 0px #000e330d;

  font-family: "YuGothic", sans-serif;
  font-weight: 700;
  line-height: 1.5;
  letter-spacing: 0;
  text-align: center;

  ${MEDIA_QUERY_FOR_PC} {
    font-size: 16px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    font-size: 12px;
  }
`;

export const monthPickerContainerStyle = css`
  height: 396px;
  opacity: 1;
  border-radius: 16px;
  padding: 24px;
  background: #f9f9f9;
  border: 1px solid #e6e6e6;
  box-shadow: 0px 1px 2px 0px #000e3340;

  ${MEDIA_QUERY_FOR_PC} {
    width: 440px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    width: 336px;
  }
`;

export const monthGridStyle = css`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px 4px;
  align-content: start;
  margin-top: 16px;
`;

export const monthButtonStyle = css`
  cursor: pointer;
  font-family: "YuGothic", sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #1f1f1f;
  gap: 10px;
  border-radius: 6px;
  padding: 13px 20px;
  border: none;
  background: #ffffff;
  box-shadow: 0px 1px 1px 0px #000e330d;
  &:hover {
    background: #e9ecef;
  }

  ${MEDIA_QUERY_FOR_PC} {
    height: 44px;
    width: 128px;
  }
`;
